import { CircularProgress } from '@mui/material';
import React from 'react';
import { Outlet, useNavigate } from 'react-router';

import { useAutoSignIn } from '../../../../shared/hooks/accountHook';
import { centeredCircularProgressStyle } from '../../common/styles';

export interface ProtectedRouteProps {
  notLoggedInComponent?: JSX.Element;
}
export const ProtectedRoute: React.FC<ProtectedRouteProps> = (
  props: ProtectedRouteProps,
) => {
  const { data: user } = useAutoSignIn();

  return (
    <>
      {!user && <CircularProgress style={centeredCircularProgressStyle} />}
      <Outlet />
    </>
  );
};

export const IdentificationProtectedRoute: React.FC<ProtectedRouteProps> = (
  props: ProtectedRouteProps,
) => {
  const { data: user } = useAutoSignIn();
  const navigate = useNavigate();
  if (user && !user.identified) {
    navigate('/');
  }
  return <ProtectedRoute {...props} />;
};
